/// <reference path='../_all.ts' />

module library {
  'use strict';

  export class Product {
    constructor(
      public Name : string,
      public Url : string
      ) { }
  }  
  
  
  export class DocumentDetailServiceData {
    constructor(
      public Document : Document,
      public Languages : Language[],
      public ReplacedBy : ReplacedByData[],
      public Products : Product[],
      public CrossReference: DocumentCrossReferenceType[],
      public IsImage: boolean,
      public Revision : DocumentRev,
      public selectedRevision : Revision,
      public selectedLanguageVariant : LanguageVariant,
      public selectedFileType : FileType,
      public LanguageVariants : LanguageVariant[]
      ) { }
  }

}
